import React, { Component } from 'react';
import styles from '../../../Assets/Styles/Components/Book/Photograpers/star.module.css';

class Star extends Component {
    render() {
        return <div className={styles.stars} style={{ '--rating': `${this.props.rate}` }} />;
    }
}

export default Star;
